var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { useState } from "react";
import Notification from "./Notification";
var noop = function () {
    //np
};
export var showToastMessage = noop;
var ToastMessage = function () {
    var _a = useState({
        isOpen: false,
        message: "",
        type: "success",
    }), notification = _a[0], setNotification = _a[1];
    showToastMessage = function (data) {
        setNotification(__assign(__assign({}, notification), data));
    };
    var closeNotification = function () {
        setNotification(__assign(__assign({}, notification), { isOpen: false }));
    };
    return (React.createElement(Notification, { isOpen: notification.isOpen, type: notification.type, message: notification.message, handleClose: closeNotification }));
};
export default ToastMessage;
//# sourceMappingURL=ToastMessage.js.map